import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperadminAuth } from '../../contexts/SuperadminAuthContext';
import { SUPERADMIN_ROUTES } from '../../routes/routes';
import SuperadminLoginForm from '../../components/SuperadminLoginForm';

const SuperadminLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useSuperadminAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate(SUPERADMIN_ROUTES.DASHBOARD, { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  // Don't render anything while checking auth or if already authenticated
  if (loading || isAuthenticated) {
    return null;
  }

  return <SuperadminLoginForm />;
};

export default SuperadminLoginPage;
